import React, { memo } from 'react';
import { useI18n } from '../../../../i18n';

import S from './style/ActionSafeDeal';

const ActionSafeDeal: React.FC<{
  onAccept: React.EventHandler<React.MouseEvent>;
  onReject: React.EventHandler<React.MouseEvent>;
}> = function ActionSafeDeal({ onAccept, onReject }) {
  const i18n = useI18n();

  return (
    <S.OrderActions data-testid="safe-deal-order-actions">
      <S.BtnContainer>
        <S.RejectBtn
          size="small"
          data-cy="safe-deal-fraud-button"
          data-testid="safe-deal-fraud-button"
          onClick={onReject}
        >
          {i18n('dlv_safedeal_fraud_button')}
        </S.RejectBtn>
      </S.BtnContainer>
      <S.BtnContainer>
        <S.AcceptBtn
          size="small"
          data-cy="safe-deal-ok-button"
          data-testid="safe-deal-ok-button"
          onClick={onAccept}
        >
          {i18n('dlv_safedeal_item_ok_button')}
        </S.AcceptBtn>
      </S.BtnContainer>
    </S.OrderActions>
  );
};

export default memo(ActionSafeDeal);
